<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")
      v-card(min-height="80vh")
        v-card-title.px-5(:style="`background-color: ${$vuetify.theme.themes[$theme].basic100}`")
          v-row(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="showModal = !showModal" height)
                eva-icon(name="arrow-back-outline" :fill="$vuetify.theme.themes[$theme].basic800" width="24" height="24")
            v-col.ml-3
              p.mb-0.h6.basic800--text {{ $t('submit_your_ideas') }}
        v-card-text.px-0
          v-form(ref="form")
            v-card.ma-4.mt-0.pa-4(flat style="border:1px solid var(--v-basic400);")
              .s1 {{ $t('tell_us_more') }}
              .c1.basic600--text {{ $t('what_should_we_build') }}

              .category.mt-6
                .label.basic600--text.text-uppercase {{ $t('select_category') }}
                v-select.mt-2(v-model="form.data.category" item-text="name" item-value="id" :items="categories" outlined dense background-color="basic200" placeholder="Select category" :rules="rules.is_selected" return-object :loading="isFetchingCategories")
                  template(v-slot:append)
                    eva-icon(name="chevron-down-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")

                  template(v-slot:item="{ index, item, attrs }")
                    v-layout
                      v-list-item-content
                        v-list-item-title.s1(:class="attrs.inputValue ? 'white--text' : 'primary--text'") {{ item.name }}
                        v-list-item-subtitle.c1(v-if="item.description" :class="attrs.inputValue ? 'white--text' : 'primary--text'") {{ item.description }}

              .title
                p.mb-1.label.basic600--text.text-uppercase {{ $t('title') }}
                v-text-field.mt-2(v-model='form.data.title' :placeholder="$t('a_feature_that_help')" background-color="basic200" outlined dense height="40" persistent-hint :rules="rules.not_empty")

              .description
                p.mb-1.label.basic600--text.text-uppercase {{ $t('description_optional') }}
                v-textarea.mt-2(v-model='form.data.description' :placeholder="$t('tell_more_about_feature')" outlined dense persistent-hint background-color="basic200")
              
              .email
                p.mb-1.label.basic600--text.text-uppercase {{ $t('email_optional') }}
                v-text-field.mt-2(v-model='form.data.email' :placeholder="$t('get_notified_from_us')" background-color="basic200" outlined dense height="40" persistent-hint :rules="form.data.email ? rules.email : []")
              
              .document
                v-row.mt-4(no-gutters align="center")
                  v-col.shrink
                    v-img.mr-4(:src="form.documentImage.url ? form.documentImage.url : require('@/assets/image_placeholder.png')" width="95px" aspect-ratio="1")
                  v-col
                    div.file-layout
                      v-btn.button-AA-tiny.text-uppercase(color="textColorAccent" outlined x-small height="24" :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}") {{ $t('upload_image') }}
                      input.input-layout(type="file" @change="onFileChange" accept="image/*")
                    div.c1.basic600--text.mt-4 {{ $t('upload_photo_to_help_us') }}
              v-layout
                v-spacer
                v-btn(color='info500' depressed @click="clickProceed()" :loading="isLoading")
                  .button-AA-medium.basic100--text {{ $t('submit') }}
          
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { resizeImage } from '@/utils'

export default {
  name: 'SubmitNewIdeaDialog',
  props: ['open'],
  data: () => ({
    isFetching: false,
    form: {
      data: {
        category: null,
        title: null,
        description: '',
        email: null
      },
      documentImage: {
        url: '',
        file: null,
      }
    },
    isLoading: false,
    isFetchingCategories: false,
    categories: [],
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      is_selected: [(v) => v !== null || 'This field is required'],
      email: [
        v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid',
      ]
    }
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
    this.fetchCategories()
  },
  methods:{
    ...mapActions([
      'showMessage'
    ]),
    fetchCategories () {
      this.isFetchingCategories = true
      this.$feedbackApi.get('/items/categories')
        .then((response) => {
          this.isFetchingCategories = false
          this.categories = [ ...response.data.data ]
          this.form.data.category = this.categories[0]
        }).catch(() => {})
    },
    async clickProceed() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      let imageId = ''
      if (this.form.documentImage.file) {
        try {
          var params = new FormData()
          params.append('file', this.form.documentImage.file)
          let resp = await this.$feedbackApi.post('/files', params)
          imageId = resp.data.data.id
        } catch {
          imageId = ''
        }
      }
      const data = {
        original_category_id: this.form.data.category.id,
        published_category_id: this.form.data.category.id,
        original_title: this.form.data.title,
        published_title: this.form.data.title,
        original_description: this.form.data.description,
        published_description: this.form.data.description,
      }
      if (imageId) {
        data['original_image'] = imageId
        data['published_image'] = imageId
      }
      this.$feedbackApi.post('/items/feedbacks', data)
        .then((response) => {
          if (this.form.data.email) {
            const data = {
              email: this.form.data.email,
              feedback_id: response.data.data.id,
            }
            this.$feedbackApi.post('/items/notifications', data).catch(() => {})
          }
          this.showMessage(['success', this.$t('success_message.your_idea_recorded')])
          this.showModal = false
        }).catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => { this.isLoading = false })
    },
    async onFileChange (e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      let imageName = 'idea_image.jpeg'
      if (this.form.data.title && this.$options.filters.slugify(this.form.data.title.toString())) {
        imageName = `${this.$options.filters.slugify(this.form.data.title.toString())}.jpeg`
      }
      const resizedImage = await resizeImage(files[0], imageName)
      this.form.documentImage.url = resizedImage.dataURL
      this.form.documentImage.file = resizedImage.file
    }
  },
}
</script>

<style scoped>
.file-layout {
  position: relative;
  cursor: pointer;
}
.input-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
div >>> .v-list-item--active{
  background-color: var(--v-info500) !important;
  color:white !important;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "submit_your_ideas": "Submit your ideas",
    "tell_us_more": "Tell us more about your ideas",
    "what_should_we_build": "What should we build next to make Yezza more useful for you?",
    "select_category": "Select category",
    "a_feature_that_help": "A feature that will help your business",
    "description_optional": "Description (Optional)",
    "tell_more_about_feature": "Tell more about the feature. Be more specific and write out the details.",
    "email_optional": "Email (Optional)",
    "get_notified_from_us": "Get notified from us for this feature.",
    "upload_image": "Upload image",
    "upload_photo_to_help_us": "Upload photo to help us understand your request better"
  },
  "id": {
    "submit_your_ideas": "Tambah Kritik dan Saran",
    "tell_us_more": "Ceritakan lebih banyak tentang ide kamu",
    "what_should_we_build": "Apa yang harus kami bangun selanjutnya untuk membuat Yezza lebih bermanfaat bagi kamu?",
    "select_category": "Pilih Kategori",
    "a_feature_that_help": "Fitur yang akan membantu bisnis kamu",
    "description_optional": "Deskripsi (opsional)",
    "tell_more_about_feature": "Ceritakan lebih banyak tentang fitur tersebut. Lebih spesifik dan tulis detailnya",
    "email_optional": "Email (opsional)",
    "get_notified_from_us": "Dapatkan pemberitahuan dari Yezza untuk fitur ini",
    "upload_image": "Unggah foto",
    "upload_photo_to_help_us": "Unggah foto untuk membantu kami memahami permintaan kamu dengan lebih baik"
  }
}
</i18n>
